import { FieldBase } from '@/components/form';
import { ArbeitstageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/ArbeitstageSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Toggle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function DreiMonatsdurchschnittFields() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <form.AppField name="abwesenheiten.allgemein.dynamisch_drei_monatsschnitt_berechnungsgrundlage">
      {(field) => (
        <div className="flex flex-col gap-4">
          <FieldBase
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.label',
            )}>
            <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
              <Toggle
                pressed={field.state.value === 'moegliche_arbeitstage'}
                onPressedChange={() =>
                  field.handleChange('moegliche_arbeitstage')
                }
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                {t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.options.moegliche_arbeitstage',
                )}
              </Toggle>
              <Toggle
                pressed={field.state.value === 'anzahl_sv_tage'}
                onPressedChange={() => field.handleChange('anzahl_sv_tage')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                {t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.options.anzahl_sv_tage',
                )}
              </Toggle>
            </div>
          </FieldBase>
          {field.state.value === 'moegliche_arbeitstage' && (
            <ArbeitstageSelect hideOptionFlexibel />
          )}
        </div>
      )}
    </form.AppField>
  );
}
